import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { auth } from "./config/firebase";
import "./Reset.css";
import LoadingScreen from "./components/LoadingScreen";
import { Alert } from "react-bootstrap";
import { sendPasswordResetEmail } from "firebase/auth";

function Reset() {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [alert, setAlert] = useState({ type: null, message: null });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setLoading(false);
    });

    // Get group and course from URL query parameters
    const searchParams = new URLSearchParams(location.search);
    const group = searchParams.get('group');
    const course = searchParams.get('course');

    // Store group and course in localStorage if they exist
    if (group) localStorage.setItem('group', group);
    if (course) localStorage.setItem('course', course);

    return () => unsubscribe();
  }, [location]);

  const handlePasswordReset = async () => {
    try {
      await sendPasswordResetEmail(auth, email);
      setAlert({ type: "success", message: "Password reset email sent! Please check your inbox." });
    } catch (err: any) {
      console.error("Error sending reset email:", err);
      if (err.code === "auth/invalid-email") {
        setAlert({ type: "danger", message: "Invalid email address" });
      } else if (err.code === "auth/user-not-found") {
        setAlert({ type: "danger", message: "No user found with this email address" });
      } else {
        setAlert({ type: "danger", message: "Failed to send reset email" });
      }
    }
  };

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <div className="reset">
      <div className="text-center px-3">
        <p>Reset your password by entering the email address for your account below.</p>
        {alert.type && alert.message && <Alert variant={alert.type}>{alert.message}</Alert>}

        <input
          type="text"
          className="form-control d-block w-100 mb-3 p-2 text-center"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="E-mail Address"
        />
        <button
          className="btn btn-primary w-100 btn-block mb-3"
          onClick={handlePasswordReset}
        >
          Send password reset email
        </button>
        <small className="text-muted text-sm-center d-block mb-2">
          Don't have an account? <Link to="/page/register">Register</Link> now.
        </small>
        <small className="text-muted text-sm-center d-block">
          <Link to="/">Back to Login</Link>
        </small>
      </div>
    </div>
  );
}

export default Reset;
